import { render, staticRenderFns } from "./MPesaPaymentPage.vue?vue&type=template&id=5beb6f96&"
import script from "./MPesaPaymentPage.vue?vue&type=script&lang=js&"
export * from "./MPesaPaymentPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5beb6f96')) {
      api.createRecord('5beb6f96', component.options)
    } else {
      api.reload('5beb6f96', component.options)
    }
    module.hot.accept("./MPesaPaymentPage.vue?vue&type=template&id=5beb6f96&", function () {
      api.rerender('5beb6f96', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MPesaPaymentPage.vue"
export default component.exports